var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-column"},[_c('md-switch',{model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v("\n    "+_vm._s(_vm.tx(_vm.model))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }